export default __webpack_public_path__ + "static/media/date-icon.6c5dece8.svg";